import { clsx } from 'clsx'
import { PropsWithChildren } from 'react'

interface BlockProps extends PropsWithChildren {
  className?: string
}

export function Block({ className, children }: BlockProps): React.JSX.Element {
  return (
    <div className={clsx('flex flex-col rounded-2xl border border-solid border-gray-100 p-4', className)}>
      {children}
    </div>
  )
}
